export const SET_IS_LOADING = 'SET_IS_LOADING';
export const SET_LOADING = 'SET_LOADING';
export const SET_IS_RESULTS_LOADING = 'SET_IS_RESULTS_LOADING';
export const SET_IS_SHOW_BOTTOM_BAR = 'SET_IS_SHOW_BOTTOM_BAR';
export const SET_IS_BATCH_SELECT = 'SET_IS_BATCH_SELECT';
